module.exports = __webpack_public_path__ + "img/QuatriemeCouvertureLMDS-550.309d7b32.png";